import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { AccountAPI } from '../../services/accountAPI';
@inject(AuthService, UserMessageService, Router, AccountAPI)
export class Videos {
    constructor(authService, userMessageService, router, api) {

        this.authService = authService;
        this.userMessageService = userMessageService;
        this.router = router;
        this.api = api;
       
       

    }
    activate() {

        this.subscriptionType = this.authService.getAccount().subscription_type || '';
        this.isAdmin = this.authService.getUser().role == "ADMIN" || this.authService.getUser().role == "WLADMIN";
        this.setData();
        
        this.load();

        

        this.testimonial_expire_days = window.testimonial_expire_days;
        
    }

    attached() {
        this.requestList.activate();
        this.submissionList.activate();
        this.brandVideoList.activate();
        if(this.subscriptionType.startsWith('PLUS') || this.isAdmin)
            this.videoEmailList.activate();
        if(this.subscriptionType.startsWith('PLUS') || this.isAdmin)
            this.videoMessageList.activate();    
        if(this.subscriptionType.startsWith('PLUS') || this.isAdmin)
            this.caseStudyList.activate();
    }

    load() {
        this.api.getByOwner(
            this.authService.getUser().token, 
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
    }

    saveLoadSuccess(data) {
        this.authService.setAccount(data);
        this.setData();
    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
    }

    setData() {
        this.requestCount = this.authService.getAccount().request_count;
        
    }
}
